"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.folded = folded;
/**
 * Lower case with the accents taken off, so `gab` finds *Gábor* — a Hungarian list typed into from
 * a keyboard that is not always set to Hungarian (13 Oct 2026). `NFD` splits a letter from its mark
 * and the range drops the marks; `ő` and `ű` decompose like the rest.
 *
 * ⚠️ Shared by `Select`'s search and the list toolbar's filter search, so the two match alike.
 */
function folded(text) {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
}
//# sourceMappingURL=folded.js.map